import {
  GET_PURCHASED_HARDWARE,
  GET_HARDWARE_ITEMS,
  GET_HARDWARE_REQUEST,
  GET_HARDWARE_PROPOSAL,
  GET_HARDWARE_MOVMENT,
  GET_HARDWARE_COLLECTOR,
  GET_HARDWARE_INVENTORY,
  GET_HARDWARE_DISTRIBUTERS,
} from '../constants/HardwareArea';

const initState = {
  hardwareItems: [],
  purchasedHardware: {},
  hardwareRequests: {},
  hardwareProposals: {},
  hardwareMovmentReport: [],
  hardwareCollectortReport: {},
  hardwareInventorytReport: {},
  hardwareDistributers: {},
};

const hardwareSupplyArea = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_HARDWARE_ITEMS:
      return { ...state, hardwareItems: payload };
    case GET_PURCHASED_HARDWARE:
      return { ...state, purchasedHardware: payload };
    case GET_HARDWARE_REQUEST:
      return { ...state, hardwareRequests: payload };
    case GET_HARDWARE_PROPOSAL:
      return { ...state, hardwareProposals: payload };
    case GET_HARDWARE_MOVMENT:
      return { ...state, hardwareMovmentReport: payload };
    case GET_HARDWARE_COLLECTOR:
      return { ...state, hardwareCollectortReport: payload };
    case GET_HARDWARE_INVENTORY:
      return { ...state, hardwareInventorytReport: payload };
    case GET_HARDWARE_DISTRIBUTERS:
      return { ...state, hardwareDistributers: payload };
    default:
      return state;
  }
};

export default hardwareSupplyArea;
